import React from "react";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";

import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {HomepageSearchDropdownList} from "./HomepageSearchDropdownList";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacyDesktopSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacyDesktopWrapperStyle}>
            <div className={legacySearchAutocompleteWrapperStyle}>
                <SearchAutocomplete
                    values={props.formValues}
                    onChange={props.onChange}
                    onAfterChange={props.onAfterChange}
                    onSubmit={props.autocompleteSubmit}
                    onDropdownStatusChange={props.setDesktopSearchBlendActive}
                    onAfterTabSwitch={props.onAfterTabSwitch}
                    fetchAllSearchLists={props.fetchAllSearchLists}
                    autoFocus={props.autoFocus ?? true}
                    inputIcon={<SearchBoldIcon size="2.4" />}
                    isHomepage
                    disableMultiRegion={!!props.disableMultiRegion}
                    minWidth="auto"
                    renderDropdownList={HomepageSearchDropdownList}
                />
            </div>
        </div>
    );
};

const legacyDesktopWrapperStyle = css({
    position: "relative",
    display: "none",

    md: {
        display: "flex",
        flexWrap: "wrap",
        margin: "0 auto",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: 0
    }
});

const legacySearchAutocompleteWrapperStyle = css({
    position: "relative",
    width: "100%",

    "& > div": {
        overflow: "hidden",
        borderRadius: 2,

        md: {
            p: 0
        }
    },

    "& > div > div:first-of-type": {
        borderTopLeftRadius: "1.6rem",
        borderTopRightRadius: "1.6rem"
    },

    "& > div > div:nth-of-type(2)": {
        maxHeight: "5rem",
        backgroundColor: "#fff"
    },

    "& > div > div:nth-of-type(2) > div": {
        width: "100%"
    },

    "& > div > div:nth-of-type(2) > div > div": {
        height: "50px !important",
        border: "0 !important",
        borderRadius: "0 0 1.6rem 1.6rem !important",
        backgroundColor: "#fff",
        overflow: "hidden"
    },

    "& > div > div:nth-of-type(2) > div > div > div:first-of-type": {
        width: "6.4rem !important",
        height: "100%",
        pl: "0 !important",
        pr: "0 !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--colors-primary)",
        borderBottomLeftRadius: "1.6rem"
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(2):last-child": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(2):not(:last-child)": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(3):not(:last-child)": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:last-child": {
        right: "2rem !important"
    },

    "& input": {
        fontSize: "1.6rem",
        lineHeight: "2.4rem"
    },

    "& input::placeholder": {
        color: "var(--colors-gray-700)",
        opacity: 1
    }
});
import React from "react";
import {css} from "@panda/css";

import {SearchBoldIcon} from "@pg-design/icons-module";

import {SearchAutocomplete} from "../../../search/components/search_autocomplete/SearchAutocomplete";
import {HomepageSearchDropdownList} from "./HomepageSearchDropdownList";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacyDesktopSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacyDesktopWrapperStyle}>
            <div className={legacySearchAutocompleteWrapperStyle}>
                <SearchAutocomplete
                    values={props.formValues}
                    onChange={props.onChange}
                    onAfterChange={props.onAfterChange}
                    onSubmit={props.autocompleteSubmit}
                    onDropdownStatusChange={props.setDesktopSearchBlendActive}
                    onAfterTabSwitch={props.onAfterTabSwitch}
                    fetchAllSearchLists={props.fetchAllSearchLists}
                    autoFocus={props.autoFocus ?? true}
                    inputIcon={<SearchBoldIcon size="2.4" />}
                    isHomepage
                    disableMultiRegion={!!props.disableMultiRegion}
                    minWidth="auto"
                    renderDropdownList={HomepageSearchDropdownList}
                />
            </div>
        </div>
    );
};

const legacyDesktopWrapperStyle = css({
    position: "relative",
    display: "none",

    md: {
        display: "flex",
        flexWrap: "wrap",
        margin: "0 auto",
        alignItems: "center",
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: 0
    }
});

const legacySearchAutocompleteWrapperStyle = css({
    position: "relative",
    width: "100%",

    "& > div": {
        overflow: "hidden",
        borderRadius: 2,

        md: {
            p: 0
        }
    },

    "& > div > div:first-of-type": {
        borderTopLeftRadius: "1.6rem",
        borderTopRightRadius: "1.6rem"
    },

    "& > div > div:nth-of-type(2)": {
        maxHeight: "5rem",
        backgroundColor: "#fff"
    },

    "& > div > div:nth-of-type(2) > div": {
        width: "100%"
    },

    "& > div > div:nth-of-type(2) > div > div": {
        height: "50px !important",
        border: "0 !important",
        borderRadius: "0 0 1.6rem 1.6rem !important",
        backgroundColor: "#fff",
        overflow: "hidden"
    },

    "& > div > div:nth-of-type(2) > div > div > div:first-of-type": {
        width: "6.4rem !important",
        height: "100%",
        pl: "0 !important",
        pr: "0 !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "var(--colors-primary)",
        borderBottomLeftRadius: "1.6rem"
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(2):last-child": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(2):not(:last-child)": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:nth-of-type(3):not(:last-child)": {
        height: "50px",
        pl: 3,
        pr: 3,
        border: 0,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },

    "& > div > div:nth-of-type(2) > div > div > div:last-child": {
        right: "2rem !important"
    },

    "& input": {
        fontSize: "1.6rem",
        lineHeight: "2.4rem"
    },

    "& input::placeholder": {
        color: "var(--colors-gray-700)",
        opacity: 1
    }
});
